(function() {
  // registers a Dialog Service 'CfnDialogService'
  // methods:
  angular.module('cfn').factory('CfnDialogService', CfnDialogService);

  CfnDialogService.$inject = ['$dialog', 'i18nFilter'];

  function CfnDialogService($dialog, i18nFilter) {
    var ob = {};
    var defaultOkLabel = i18nFilter('fe.common.ok', 'OK');
    var dialogDisplayStatus = {
      ackDialog: false,
      yesNoDialog: false,
    };

    return {
      showAckDialog: showAckDialog,
      showYesNoDialog: showYesNoDialog,
      confirm: confirm,
      showMessage: showMessage
    };

    //	shows an acknowledge dialog with a title, a detail message, and a cancel and ok (?acknowledge) button
    //    title:         the title of the dialog
    //    message:       the details message (optional, defaults to "are you sure?")
    //    okLabel        label of OK Button  ( optional, defaults to "OK")
    //    okCallback     callback function, called if ok button pressed
    //  title and okCallback are always mandatory, message is mandatory if method is called with 3 arguments
    function showAckDialog(title, message, okLabel, okCallback, notOkCallback) {
      if (dialogDisplayStatus.ackDialog) {
        return;
      }
      dialogDisplayStatus.ackDialog = true;
      if (arguments.length == 3) {
        okCallback = okLabel;
        okLabel = defaultOkLabel;
      }
      if (arguments.length == 2) {
        okCallback = message;
        message = i18nFilter('fe.common.areYouSure', 'Sind Sie sicher?');
        okLabel = defaultOkLabel;
      }
      return $dialog
        .messageBox(title, message, [
          {
            result: 'cancel',
            label: i18nFilter('fe.common.cancel', 'Abbruch'),
            cssClass: 'test-modal-btn-secondary'
          },
          {
            result: 'ok',
            label: okLabel,
            cssClass: 'test-modal-btn-primary btn-primary'
          }
        ])
        .open()
        .then(function(result) {
          dialogDisplayStatus.ackDialog = false;

          if (result == 'ok') {
            okCallback();
          } else if (notOkCallback) notOkCallback();
        });
    }

    function showYesNoDialog(
      title,
      message,
      yesCallback,
      noCallback,
      cancelCallback,
      extendOptions
    ) {
      if (dialogDisplayStatus.yesNoDialog) {
        return;
      }

      dialogDisplayStatus.yesNoDialog = true;
      
      var yesLabel = i18nFilter('fe.common.label.yes', 'Yes');
      var noLabel = i18nFilter('fe.common.label.no', 'No');
      extendOptions = typeof b === 'object' ? extendOptions : {};

      var buttons = [
        {
          result: 'no',
          label: noLabel
        },
        {
          result: 'yes',
          label: yesLabel,
          cssClass: 'btn-primary'
        }
      ];

      var defaultOpts = {
        templateUrl: 'template/dialog/message.html', // get's loaded from ui bootstrap tpls and put into $templateCache
        controller: 'MessageBoxController',
        backdropClick: true,
        resolve: {
          model: function() {
            return {
              title: title,
              message: message,
              buttons: buttons
            };
          }
        }
      };

      var opts = angular.extend({}, defaultOpts, extendOptions);

      return $dialog
        .dialog(opts)
        .open()
        .then(function(result) {
          dialogDisplayStatus.yesNoDialog = false;

          if (result === 'yes') {
            yesCallback();
          } else if (result === 'no') {
            if (noCallback) {
              noCallback();
            }
          } else {
            // Window closed -> no answer selected
            if (cancelCallback) {
              cancelCallback();
            }
          }
        });
    }

    /**
     * OK-Cancel dialog asking user to confirm or reject delete operation. OK-Button has label "Delete".
     * @param okCallback action to be taken on OK.
     */
    function confirm(okCallback) {
      showAckDialog(
        i18nFilter('fe.common.message.reallyDelete.title', 'Wirklich löschen?'),
        i18nFilter(
          'fe.common.message.reallyDelete.message',
          'Sind Sie sicher, dass Sie dieses Element löschen wollen?'
        ),
        i18nFilter('fe.common.delete', 'Löschen'),
        okCallback
      );
    }

    /*
         * Shows an info message with a title, a detail message and an OK button.
         * title:         the title of the dialog
         * message:       the details message
         * okLabel        label of OK Button  ( optional, defaults to "OK")
         *
         */
    function showMessage(title, message, okLabel) {
      if (!okLabel) {
        okLabel = defaultOkLabel;
      }
      return $dialog
        .messageBox(title, message, [
          {
            result: 'ok',
            label: okLabel,
            cssClass: 'btn-primary'
          }
        ])
        .open();
    }
  }
})();
